
// Base endpoints
const V2_ENDPOINT = process.env.REACT_APP_API_ENDPOINT // v2 (default)
const V1_ENDPOINT = process.env.REACT_APP_API_ENDPOINT.replace('/v2', '/v1')

// V1 specific APIs
export const fetchUrl = V1_ENDPOINT + '/getImages'

// Pronto API URLs (v1)
export const prontoLoginUrl = V1_ENDPOINT + '/prontoLogin'
export const prontoProductsUrl = V1_ENDPOINT + '/fetchProntoProductsInfo'

// Store API URLs (v1)
export const saveLabelsUrl = V1_ENDPOINT + '/updateShelfEdgeList'
export const getSavedLabelsUrl = V1_ENDPOINT + '/fetchShelfEdgeList'

// Clearance Labels API URLs
export const fetchClearanceReportsUrl = V2_ENDPOINT + '/clearance/fetchReports'
export const fetchClearanceLabelUrl = V2_ENDPOINT + '/clearance/fetchLabel'

// Category API URLs
export const categoryUrl = V2_ENDPOINT + '/category'
export const fetchCategoryListUrl = V2_ENDPOINT + '/category/list'
export const reorderCategoryUrl = V2_ENDPOINT + '/category/reorder'
export const searchCategoryProductsUrl = V2_ENDPOINT + '/category/products/search'

// Inventory Movement API URLs
export const inventoryMovementProductsUrl = V2_ENDPOINT + '/inventoryMovement/products'
export const inventoryMovementProductsLookupUrl = V2_ENDPOINT + '/inventoryMovement/products/lookup'
export const inventoryMovementsUrl = V2_ENDPOINT + '/inventoryMovement/movements'
export const inventoryMovementAlertEmailsUrl = V2_ENDPOINT + '/inventoryMovement/alertEmails'
